// Normalizes a string for accent-insensitive, case-insensitive search.
// Strips diacritics (e.g. "Café" -> "cafe") so a plain ASCII query matches
// accented names and vice-versa. Client-side only — does not affect API calls.
export const normalizeForSearch = (value) => {
  if (!value) return '';
  return value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
};

export const formatDate = (isoDateString) => {
  if (!isoDateString) return '';

  const date = new Date(isoDateString);
  const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();

  // return `${year}-${month}-${day}`;
  return `${day}-${month}-${year}`;
};

// RAT-1865: same filter shape as the Merchant list API params (minus pagination),
// so a "Current filter results" export matches exactly what is on screen. Empty
// filters are omitted rather than sent as blanks.
export const buildMerchantExportFilters = (params, search) => {
  const filters = { search, isHidden: params.archivedView === 'true' };
  [
    'inMaintenance',
    'isTemporarilyClosed',
    'isComingSoon',
    'legalInfoStatus',
    // RAT-1690: the label filter counts too, or an export of "current results"
    // would silently ignore it and return more rows than the screen shows.
    'labelIds',
  ].forEach((key) => {
    if (params[key] !== '' && params[key] !== undefined) {
      filters[key] = params[key];
    }
  });
  return filters;
};

export const formatCurrency = (amount, currency = 'EUR') => {
  // eslint-disable-next-line no-undef
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};
